export function isAbsoluteUrl(address) {
  if (!address) {
    return false;
  }
  const isHttp = address.startsWith('http://') || address.startsWith('https://');
  const isWs = address.startsWith('ws://') || address.startsWith('wss://');

  return isHttp || isWs;
}

export function isRelativeUrl(address) {
  return address && address.startsWith('/');
}

export function getEndpointUrl(address) {
  let url;
  if (isAbsoluteUrl(address)) {
    url = new URL(address);
  } else {
    const envPublicUrl = process.env.PUBLIC_URL ?? '/';
    url = new URL(envPublicUrl, window.location);
    if (isRelativeUrl(address)) {
      url.pathname = url.pathname.trimEnd('/') + address;
    }
  }

  return String(url);
}